import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/shared/api/queryKeys';
import { fetchLocalDeviceUncached, type LocalDeviceInfo } from '@/shared/lib/octo/localDevice';

export { fetchLocalDevice, LOCAL_AGENT_PORT, type LocalDeviceInfo } from '@/shared/lib/octo/localDevice';

/** Yerel ajan kimliği; yoksa `data === null`. Dakikada bir yenilenir, hata üretmez. */
export function useLocalDevice(enabled = true) {
  return useQuery<LocalDeviceInfo | null>({
    queryKey: queryKeys.device.local(),
    queryFn: () => fetchLocalDeviceUncached(),
    enabled,
    staleTime: 30_000,
    refetchInterval: 60_000,
    retry: false,
  });
}
